// @flow

const uuidRegEx = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const BSS_URL_BASENAME_PREFIX = '';
// eslint-disable-next-line import/prefer-default-export
export { uuidRegEx, BSS_URL_BASENAME_PREFIX };
